import { gql } from '@apollo/client';

export interface AreaInfoType {
  id: number | null;
  name: string;
}

export interface DspAreasData {
  areas: AreaInfoType[];
}

export interface GetDspAreasResponse {
  getDspAreas: DspAreasData;
}

export const GET_DSP_AREAS = gql`
  query DspQuery($warehouseId: Long) {
    getDspAreas(warehouseId: $warehouseId) {
      areas {
        id
        name
      }
    }
  }
`;

